import api from "../utils/api";

/** Login step 2: exchange challenge + emailed code for tokens. */
export async function verifyLoginCode(challenge, code) {
  return api.post("/api/users/login/2fa/verify/", { challenge, code });
}

/** Login step 2: request a fresh code (60s server-side cooldown). */
export async function resendLoginCode(challenge) {
  return api.post("/api/users/login/2fa/resend/", { challenge });
}

/** Settings: current user's 2FA state. */
export async function fetchTwoFactorStatus() {
  return api.get("/api/users/two-factor/", { auth: true });
}

/** Settings: email a setup code to the user. */
export async function requestTwoFactorEnable() {
  return api.post("/api/users/two-factor/request-enable/", {}, { auth: true });
}

/** Settings: confirm the setup code and switch 2FA on. */
export async function confirmTwoFactorEnable(code) {
  return api.post("/api/users/two-factor/enable/", { code }, { auth: true });
}

/** Settings: switch 2FA off (requires the account password). */
export async function disableTwoFactor(password) {
  return api.post("/api/users/two-factor/disable/", { password }, { auth: true });
}
